"use strict";


function Common() {
}

export default Common;

//====================================//
//=====PROJECT SPECIFIC VARIABLES=====//
//====================================//

/**
 * @param arr
 */
Common.buttonsAppear = function (arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            delay: i * 0.15
        });
    }
};

/**
 * @param arr
 * @param cb
 */
Common.buttonsOut = function (arr, cb) {
    for (let i = 0; i < arr.length; i++) {
        // arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [2],
            delay: i * 0.15 + 0.25,
            onComplete: () => {
                if (cb && i === arr.length - 1) cb();
            }
        });
    }
};

//====================================//
//========PROJECT SPECIFIC END========//
//====================================//

/**
 * @type {P3.View}
 */
Common.view = null;

/**
 * @type {number}
 */
Common.paused = false;

/**
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 */
Common.isDebug = false;

//===============//
//==static vars==//
//===============//

/**
 * Semi unique key used as an identifier for save files, followed by company code and the version
 * (useful if you want players to start a new game, increment version number)
 * @constant @static
 * @type {string}
 */
Common.game_key = "z8dxl9mt-HAD_v1";

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {P3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @type {boolean}
 * @static
 */
Common.tabActive = false;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_WIDTH = 1920;
Common.W2 = Common.STAGE_WIDTH * 0.5;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_HEIGHT = 824;
Common.H2 = Common.STAGE_HEIGHT * 0.5;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

//===============//
//==static ends==//
//===============//

//================================//
//=====save and load functions====//
//================================//

Common.saveMute = function () {
    const data = {isMute: Common.audio.isMute};
    localStorage.setItem(Common.game_key + "_isMute", JSON.stringify(data));
};

Common.loadMute = function () {
    const data = JSON.parse(localStorage.getItem(Common.game_key + "_isMute"));
    if (data) Common.audio.mute(data.isMute);
};

Common.saveGame = function () {
    const gameData = {
        completed: Common.completed,
        shownExitPanel: Common.shownExitPanel
    };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    Common.completed = [0, 0, 0];//init to -1, set to 0 for not complete on load
    const gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.completed = gameData.completed;
        Common.shownExitPanel = gameData.shownExitPanel;
        Common.isFirstPlay = false;
    } else {
        Common.isFirstPlay = true;
    }
};

Common.getData = function (key) {
    return JSON.parse(localStorage.getItem(key));
};

Common.setData = function (key, data) {
    localStorage.setItem(key, JSON.stringify(data));
};

//=========================================================//
//=============Rest is all util type functions=============//
//=========================================================//

/**
 * Knuth shuffle variant
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    const a = string.split(""); //our array
    const n = a.length; //number of elements
    for (let i = n - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = function (a) {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    strLen = strLen || 8;
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    return Math.atan2(dy, dx);
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

Common.compareXY = function (point1, point2) {
    return (Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y));
};

Common.lookAt = function (sprite, target, update) {
    const rotation = (Math.atan2(target.y - sprite.y, target.x - sprite.x));
    if (update) sprite.rotation = rotation;
    return rotation;
};

//--from stackoverflow-- https://stackoverflow.com/questions/14962018/detecting-and-fixing-circular-references-in-javascript //
Common.detectCircularRef = function (obj) {

    return detectCircularReferences(obj);

    function detectCircularReferences(toBeStringifiedValue, serializationKeyStack = []) {
        Object.keys(toBeStringifiedValue).forEach(key => {
            var value = toBeStringifiedValue[key];
            var serializationKeyStackWithNewKey = serializationKeyStack.slice();
            serializationKeyStackWithNewKey.push(key);
            try {
                JSON.stringify(value);
            }
            catch (error) {
                var isCircularValue;
                var circularExcludingStringifyResult = "";
                try {
                    circularExcludingStringifyResult = JSON.stringify(value, replaceRootStringifyReplacer(value), 2);
                    isCircularValue = true;
                }
                catch (error) {
                    detectCircularReferences(value, serializationKeyStackWithNewKey);
                    isCircularValue = false;
                }
                if (isCircularValue) {
                    throw new Error(`Circular reference detected:\nCircularly referenced value is value under path "${joinStrings(serializationKeyStackWithNewKey)}" of the given root object\n` +
                        `Calling stringify on this value but replacing itself with [Circular object --- fix me] ( <-- search for this string) results in:\n${circularExcludingStringifyResult}\n`);
                }
            }
        });
    }

    function replaceRootStringifyReplacer(toBeStringifiedValue) {
        var serializedObjectCounter = 0;
        return function (key, value) {
            if (serializedObjectCounter !== 0 && typeof (toBeStringifiedValue) === 'object' && toBeStringifiedValue === value) {
                return '[Circular object --- fix me]';
            }
            serializedObjectCounter++;
            return value;
        };
    }

    function joinStrings(arr, separator = ":") {
        if (arr.length === 0)
            return "";
        return arr.reduce((v1, v2) => `${v1}${separator}${v2}`);
    }
};

//from https://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
Common.getAndroidVersion = function (ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    const match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

//from https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
Common.getHash = function (string) {
    let hash = 0;
    if (string.length == 0) {
        return hash;
    }
    for (let i = 0; i < string.length; i++) {
        const char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};

/**
 * Dijkstra implementation of a path finder. Prefer this over A* if you have multiple agents with same starting position
 * and you are using a weighted graph. For non weighted graphics use BFS. For a single agent with a known single target destination use A*.
 * Or alternatively if you are unsure what your target is you can calc the path to all nodes, and then just retrieve the path to the target
 * node once you know it which could be useful depending on use case.
 *
 * @class
 */
class Dijkstra {
    constructor() {
        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        //TODO - add findPath() function which terminates when u === v
        /**
         * @type {null}
         * @private
         */
        this._target = null;//note we may want to target if we only have one agent, but A* is probably better for this case so prefer that if you don't need to guarantee the shortest path

        /**
         * Vertex set Q
         * @type {Array}
         * @private
         */
        this._verts = [];

        /**
         * @type {null}
         * @private
         */
        this._paths = null;
    }

    init() {

        if (!this._graph) throw new Error('must set graph before init');
        if (!this._source) throw new Error('must set source before init');

        //--create vertex set Q--//
        for (let x = 0; x < this._graph.length; x++) {
            for (let y = 0; y < this._graph[x].length; y++) {
                // All nodes initially in Q (unvisited nodes)
                const vert = this._graph[x][y];

                vert.distance = Number.POSITIVE_INFINITY;
                vert.prev = null;
                vert.neighbours = [];

                if (x > 0) vert.neighbours.push(this._graph[x - 1][y]);//grid sq left
                if (x < this._graph.length - 1) vert.neighbours.push(this._graph[x + 1][y]);//grid sq right
                if (y > 0) vert.neighbours.push(this._graph[x][y - 1]);//grid sq above
                if (y < this._graph[x].length - 1) vert.neighbours.push(this._graph[x][y + 1]);//grid sq below

                this._verts.push(vert);
            }
        }

        const s = this._source;
        this._verts[this._graph.length * s.x + s.y].distance = 0;//set source to source distance as zero (ensures this is first in our list becaue it has the lowest dist)

    }

    findPaths() {

        const descending = (a, b) => b.distance - a.distance;//descending sort function

        const paths = [];

        while (this._verts.length > 0) {

            //--find node with least dist by sorting--//
            // this._verts = Common.sortDistances(this._verts, true);   //highToLow
            this._verts.sort(descending); //way outperforms my quick sort function (100 to 300 percent quicker)

            const u = this._verts[this._verts.length - 1];//take last element which is the one with the shortest distance

            this._verts.pop();//remove u from vert list (Q)

            //--for each neighbour v of u--//
            for (let i = 0; i < u.neighbours.length; i++) {
                const v = u.neighbours[i];
                const sourceToV = u.distance + Dijkstra.distance(u.x, u.y, v.x, v.y);
                if (sourceToV < v.distance) {
                    //we found a new shortest distance to this node v
                    v.distance = sourceToV;//store dist
                    v.prev = u;//store prev node

                    paths.push(v);
                }
            }
        }

        this._paths = paths;

        return paths;
    }

    /**
     * Fetches the path from the this._paths pre calculated paths to all nodes
     * @param pos
     */
    retrievePathTo(pos) {
        let node;
        for (let i = 0; i < this._paths.length; i++) {
            if (Dijkstra.compareXY(pos, this._paths[i])) {
                node = this._paths[i];
            }
        }

        if (!node) {
            throw new Error("can't retrieve path, position not on graph");
        }

        const path = [];

        //--trace back to start node to create the path--//
        var recurse = () => {   //using a little recursive function to trace the path backwards
            path.push({x: node.x, y: node.y});
            if (node.prev) {
                node = node.prev;
                recurse();
            }
        };
        recurse();

        return path;
    }

    reset() {
        this.init();
    }

    test(scene) {

        const tWid = 50;
        const holder = new PIXI.Container();
        const gridSize = 15;
        const graph = Dijkstra.matrix(gridSize, gridSize);
        holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
        scene.addChild(holder);

        for (let x = 0; x < gridSize; x++) {
            for (let y = 0; y < gridSize; y++) {

                let sp = new PIXI.Sprite(PIXI.Texture.WHITE);
                holder.addChild(sp);
                sp.x = x * tWid;
                sp.y = y * tWid;

                sp.width = tWid - 2;
                sp.height = tWid - 2;

                sp.tint = 0xD8D8D8;

                graph[x][y] = {x: x, y: y};//grid should be stored as int and we will multiply out to get tile pos
            }
        }

        this.graph = graph;
        this.source = graph[0][0]; //set source to be top left

        let t0 = performance.now();
        this.init();
        const paths = this.findPaths();
        let t1 = performance.now();
        console.warn("found paths in : " + (t1 - t0));

        const path = this.retrievePathTo({x: gridSize - 1, y: gridSize - 1}); //retrieve path to bottom right

        console.log(paths);
        console.log(path);

        //--create a sprite and put it in top left corner of graph--//
        let sp = new PIXI.Sprite(PIXI.Texture.WHITE);
        holder.addChild(sp);
        sp.anchor.set(0.5);
        sp.position.set(graph[0][0].x, graph[0][0].y);
        sp.width = tWid * 0.5;
        sp.height = tWid * 0.5;

        followPath(sp, tWid, path);

        /**
         * Simple recursive function that tests the path by tweening the sprite along it
         * @param sprite
         * @param tWid
         * @param path
         */
        function followPath(sprite, tWid, path) {
            let node = path[path.length - 1];
            TweenMax.to(sprite, 0.5, {
                x: node.x * tWid,
                y: node.y * tWid + tWid * 0.5,
                ease: Power0.easeNone,
                onComplete: () => {
                    path.pop();
                    if (path.length > 0) followPath(sprite, tWid, path);
                }
            })
        }
    }

    static compareXY(point1, point2) {
        return (Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y));
    }

    static matrix(numRows, numCols, initial) {
        const arr = [];
        for (let i = 0; i < numRows; i++) {
            const columns = [];
            for (let j = 0; j < numCols; j++) columns[j] = initial;
            arr[i] = columns;
        }
        return arr;
    }

    set graph(value) {
        this._graph = value;
    }

    set source(value) {
        this._source = value;
    }

    set target(value) {
        this._target = value;
    }
}

Common.PathD = new Dijkstra();
/*
 Common.collide = function (shape1, shape2) {
 //--broad phase--//
 if (Common.collideAABB(shape1, shape2)) {
 //--narrow phase--//
 const result = Common.collideSAT(shape1, shape2);
 if (result) return result;
 }
 return false;
 };

 Common.collideAABB = function collide(r1, r2, scale = new PIXI.Point(1, 1)) {
 r1 = r1.getBounds();
 r2 = r2.getBounds();

 return !(r2.x > (r1.x + r1.width * scale.x) ||
 (r2.x + r2.width * scale.x) < r1.x ||
 r2.y > (r1.y + r1.height * scale.y) ||
 (r2.y + r2.height * scale.y) < r1.y);
 };
 */
/**
 * Created by noOne on 28/02/2018.
 */
/**
 * Collision testing with rotation, also returns overlap if a collision occurs, should be able to use overlap
 * to push the sprite out of whatever it collided with. Can take a normal sprite or display object with a list
 * of points (the vertices of your polygon as global coordinates, you must maintain this list).
 *
 * Original source - https://gist.github.com/louisstow/807250 - added fixes and adapted to PIXI
 * @param poly1 {PIXI.Sprite|PIXI.DisplayObject#points}
 * @param poly2 {PIXI.Sprite}
 * @returns {Object|Boolean}
 */
/*
 Common.collideSAT = function SAT(poly1, poly2) {
 const points1 = poly1.points === undefined ? convertVertsToVectors(poly1.vertexData) : convertVertsToVectors(poly1.points);
 const points2 = poly2.points === undefined ? convertVertsToVectors(poly2.vertexData) : convertVertsToVectors(poly2.points);

 let l = points1.length,
 k = points2.length,
 normal = {x: 0, y: 0},
 length,
 min1, min2,
 max1, max2,
 interval,
 MTV,
 dot,
 nextPoint,
 currentPoint;

 //loop through the edges of Polygon 1
 for (let i = 0; i < l; i++) {
 nextPoint = points1[(i === l - 1 ? 0 : i + 1)];
 currentPoint = points1[i];

 //generate the normal for the current edge
 normal.x = -(nextPoint[1] - currentPoint[1]);
 normal.y = (nextPoint[0] - currentPoint[0]);

 //normalize the vector
 length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
 normal.x /= length;
 normal.y /= length;

 //default min max
 min1 = min2 = -1;
 max1 = max2 = -1;

 //project all vertices from poly1 onto axis
 for (let j = 0; j < l; ++j) {
 dot = points1[j][0] * normal.x + points1[j][1] * normal.y;
 if (dot > max1 || max1 === -1) max1 = dot;
 if (dot < min1 || min1 === -1) min1 = dot;
 }

 //project all vertices from poly2 onto axis
 for (let j = 0; j < k; ++j) {
 dot = points2[j][0] * normal.x + points2[j][1] * normal.y;
 if (dot > max2 || max2 === -1) max2 = dot;
 if (dot < min2 || min2 === -1) min2 = dot;
 }

 //calculate the minimum translation vector should be negative
 interval = (min1 < min2) ? min2 - max1 : min1 - max2;

 //exit early if positive
 if (interval > 0) {
 return false;
 }
 if (interval > MTV) MTV = interval;
 }

 //loop through the edges of Polygon 1
 for (let i = 0; i < k; i++) {
 nextPoint = points2[(i === k - 1 ? 0 : i + 1)];
 currentPoint = points2[i];

 //generate the normal for the current edge
 normal.x = -(nextPoint[1] - currentPoint[1]);
 normal.y = (nextPoint[0] - currentPoint[0]);

 //normalize the vector
 length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
 normal.x /= length;
 normal.y /= length;

 //default min max
 min1 = min2 = -1;
 max1 = max2 = -1;

 //project all vertices from poly1 onto axis
 for (let j = 0; j < l; ++j) {
 dot = points1[j][0] * normal.x + points1[j][1] * normal.y;
 if (dot > max1 || max1 === -1) max1 = dot;
 if (dot < min1 || min1 === -1) min1 = dot;
 }

 //project all vertices from poly2 onto axis
 for (let j = 0; j < k; ++j) {
 dot = points2[j][0] * normal.x + points2[j][1] * normal.y;
 if (dot > max2 || max2 === -1) max2 = dot;
 if (dot < min2 || min2 === -1) min2 = dot;
 }

 //calculate the minimum translation vector should be negative
 interval = (min1 < min2) ? min2 - max1 : min1 - max2;

 //exit early if positive
 if (interval > 0) {
 return false;
 }
 if (interval > MTV) MTV = interval;
 }

 return {overlap: MTV};

 function convertVertsToVectors(verts) {
 let arr = P3.utils.marray(4, 2);

 let count = 0;
 for (let i = 0; i < verts.length; i += 2) {
 arr[count][0] = verts[i];
 arr[count][1] = verts[i + 1];
 count++;
 }

 return arr;
 }
 };
 */

/**
 * @returns Number
 */
Common.getScreenPositionLeft = function () {
    return Math.max(0, Common.STAGE_WIDTH * 0.5 - P3.View.width * 0.5);
};

/**
 * @returns Number
 */
Common.getScreenPositionRight = function () {
    return Math.min(Common.STAGE_WIDTH, Common.STAGE_WIDTH * 0.5 + P3.View.width * 0.5);
};

